<hive-progress-bar
    [percent]="effectivePercent"
    [state]="state"
    [percentagePosition]="percentagePosition"
    [label]="label"
></hive-progress-bar>
